import { NavLayout } from "@/layout/NavLayout"
import { Outlet } from "@tanstack/react-router"

export const Index = () => {
  return (
    <NavLayout>
      <Outlet />
    </NavLayout>
  )
}

